import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Chip, Button } from "@mui/material";
import { Link } from "react-router-dom";

const ArchitecturalRequestsTable = ({ rows = [], getStatusDetails }) => {
  // Ensure rows are valid and contain an 'id'
  const safeRows = Array.isArray(rows)
    ? rows.filter((r) => r && typeof r.id !== "undefined")
    : [];

  const columns = [
   
    {
      field: "property_id",
      headerName: "Property ID",
      width: 130,
    },
    {
      field: "request_type",
      headerName: "Request Type",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const status = params.row?.status || "";
        const { color = "default", Icon = null } =
          typeof getStatusDetails === "function"
            ? getStatusDetails(status)
            : {};

        return (
          <Chip
            icon={Icon ? <Icon sx={{ color: "#fff" }} /> : null}
            label={status.toUpperCase()}
            sx={{
              backgroundColor: (theme) =>
                theme.palette[color]?.main || color || "#999",
              color: "#fff",
              fontWeight: "bold",
            }}
          />
        );
      },
    },
    {
      field: "requested_at",
      headerName: "Request Date",
      width: 130,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Button
          component={Link}
          to={`${params.row?.id}`}
          variant="outlined"
          size="small"
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <div style={{ height: 500, width: "100%" }}>
      <DataGrid
        rows={safeRows}
        columns={columns}
        pageSize={10}
        disableSelectionOnClick
        getRowId={(row) => row.id}
      />
    </div>
  );
};

export default ArchitecturalRequestsTable;
